<script lang="ts">
  import { pop } from "svelte-spa-router";
  import Separator from "$shared/components/Separator.svelte";
  import { onMount } from "svelte";
  import { Ver } from "$components";
  import CardInline from "$shared/components/CardInline.svelte";
  import ListNavigationItem from "$shared/components/ListNavigationItem.svelte";

  onMount(() => {
    if (import.meta.env.DEV) console.log("Contact mounted.");
  });
</script>

<div>
  <div class="px-[24px] py-[24px] max-mobile:px-[8px] max-mobile:py-[8px]">
    <button
      on:click={() => {
        pop();
      }}
      class="-ml-[8px] min-[480px]:hidden"
    >
      <img
        src="./icons/arrow-left-small.svg"
        class="w-[24px] inline p-[8px] pb-[11px]"
        alt="arrow-left"
      />
    </button>
    <h2 class="text-[#181818] text-[17px] -mt-[30px] inline relative">
      Kontakt
    </h2>
  </div>
  <Separator customClass="max-mobile:hidden" />

  <div
    class="w-full min-[840px]:columns-2 columns-1 p-[24px] max-mobile:px-[8px]"
  >
    <CardInline title="Support och information">
      <div>
        <ListNavigationItem
          title="Support på parkando.se"
          link="https://parkando.se/kontakt"
          linkExternal={true}
          isFirst={true}
        />
        <ListNavigationItem
          title="Elbilsladdning"
          link="https://parkando.se/elbilsladdning"
          linkExternal={true}
        />
        <ListNavigationItem
          title="Kontrollavgift"
          link="https://parkando.se/kontrollavgift"
          linkExternal={true}
        />
        <ListNavigationItem
          title="Betala parkering"
          link="https://parkando.se/betala-parkering"
          linkExternal={true}
          isLast={true}
        />
      </div>
    </CardInline>

    <CardInline title="Kontaktuppgifter">
      <Ver margin="s" gap="l" mobileMargin="none">
        <div>
          <h3 class="text-[14px] text-[7E7E7E] font-semibold">Support</h3>
          <p class="py-[8px] text-[12px] text-[#58686A]">
            Växeln har öppet helgfria vardagar 07.00-17.00.
          </p>
          <a
            class="text-[16px] text-[#181818] underline"
            href="tel:0046840839638"
          >+46 (0)8-408 396 38</a>
        </div>
        <div>
          <h3 class="text-[14px] text-[7E7E7E] font-semibold">E-post</h3>
          <p class="py-[8px] text-[12px] text-[#58686A]">
            Svarar vanligtvis inom 24 timmar.
          </p>
          <a
            class="text-[16px] text-[#181818] underline"
            href="mailto:kundservice@parkando.se"
          >kundservice@parkando.se</a>
        </div>
        <div>
          <h3 class="text-[14px] text-[7E7E7E] font-semibold pb-[8px]">
            E-Huvudkontor
          </h3>
          <a
            class="text-[16px] text-[#181818] underline"
            target="_blank"
            href="https://maps.app.goo.gl/pCj1FgkY6NBcuakz7"
          >Linnégatan 51, 114 58, Stockholm</a>
        </div>
      </Ver>
    </CardInline>
  </div>
</div>
